import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'
import Close from '@Images/close_create_workspace_popup.svg'

import {
  closeCreateWorkspacePopup,
} from '@SiteModules/Popup/actions'

import {
  createWorkspace,
} from '@SiteModules/Workspace/actions'

import {
  getCurrentAccountId,
} from '@SiteModules/Account/selectors'

const WORKSPACE_NAME_MAX_LENGTH = 100

import './CreateWorkspacePopup.scss'

const CreateWorkspacePopup: React.FC = () => {
  const dispatch = useDispatch()
  const [workspaceName, setWorkspaceName] = useState('')
  const sanitizedWorkspaceName = workspaceName.trim()
  const workspaceNameLength = sanitizedWorkspaceName.length
  const workspaceNameLengthNotPossible = workspaceNameLength === 0 || workspaceNameLength > WORKSPACE_NAME_MAX_LENGTH

  const currentAccountId = useSelector(getCurrentAccountId)

  const handleCancel = () => {
    dispatch(closeCreateWorkspacePopup())
  }

  const handleCreate = () => {
    dispatch(createWorkspace({ workspaceName: sanitizedWorkspaceName, accountId: currentAccountId }))
    dispatch(closeCreateWorkspacePopup())
  }

  const changeWorkspaceName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWorkspaceName(e.target.value)
  }

  const renderButtons = () => {
    return (
      <div className="CreateWorkspacePopup__button-wrapper">
        <Button
          styleType="gray-subtle"
          size="small"
          caption="Cancel"
          onClick={handleCancel}
          icon={<Close/>}
        />
        <Button
          styleType="brand"
          size="small"
          caption="Create Workspace"
          onClick={handleCreate}
          disabled={workspaceNameLengthNotPossible}
        />
      </div>
    )
  }

  const renderWorkspaceNameInput = () => {
    return (
      <div className="CreateWorkspacePopup__input-wrapper">
        <div className="CreateWorkspacePopup__input-label">
          Workspace name
        </div>
        <input
          className="CreateWorkspacePopup__input"
          defaultValue={workspaceName}
          onChange={changeWorkspaceName}
          placeholder="Enter workspace name..."
        />
      </div>
    )
  }

  return (
    <Popup
      className="CreateWorkspacePopup"
      closePopup={handleCancel}
    >
      <div className="CreateWorkspacePopup__header">
        Create a new workspace
      </div>
      {renderWorkspaceNameInput()}
      {renderButtons()}
    </Popup>
  )
}

export default CreateWorkspacePopup
